import React from 'react';

const useOpenCloseSearchBar = (
  setIsSearchExpanded: (x: boolean) => void,
  isSearchExpanded: boolean,
): ((x: boolean) => void) => {
  const [isWritingOnInput, setIsWritingOnInput] = React.useState<boolean>(false);

  React.useEffect(() => {
    const keyDownHandler = event => {
      if (!isWritingOnInput && (event.key === '/' || event.keyCode === 191)) {
        event.preventDefault();

        setIsSearchExpanded(!isSearchExpanded);
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearchExpanded, isWritingOnInput]);

  return setIsWritingOnInput;
};

export default useOpenCloseSearchBar;
